<div fxLayout="column">
  <mat-card>
    <mat-card-header class="mb-2">
      <mat-card-title>Moduler</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div fxLayoutAlign="space-between center">
        <div fxLayout="column">
          <mat-form-field>
            <mat-label>Søg efter modul</mat-label>
            <input type="text" name="search"
              [formControl]="searchString"
              matInput>
          </mat-form-field>
          <mat-checkbox ngDefaultControl [(ngModel)]="showSelected">
            Vis kun tilføjede moduler
          </mat-checkbox>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  @if (filteredComponents$ | async; as filteredComponents) {
    <div class="component-list mt-3" [@listAnimation]="filteredComponents.length">
      @for (component of filteredComponents; track component) {
        <div
          [fxHide]="showSelected && !isSelected(component.slug)"
          >
          <mat-card class="mb-2 mr-2 component-option">
            <mat-card-content fxLayoutAlign="space-between center" fxFlex>
              <span>{{component.name}}</span>
              <div fxLayout="row" fxLayoutAlign=" center">
                @if (componentHasSettings(component.slug)) {
                  <button mat-icon-button class="mr-3"
                    (click)="editComponentSettings(component.slug)">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                <mat-slide-toggle [checked]="selectedComponents.includes(component.id)"
                  (change)="selectComponent(component.id, $event.checked)"
                ></mat-slide-toggle>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  }
</div>
